import { Zap, DollarSign, Users, TrendingUp } from "lucide-react";

const features = [
  {
    icon: <Users size={18} />,
    title: "Expert Guidance",
    description:
      "Our experienced consultants provide clear, reliable advice to help you make the right business decisions at every step.",
  },
  {
    icon: <Zap size={18} />,
    title: "Fast & Hassle-Free Process",
    description:
      "We handle the complexities of setup, visas, and compliance, ensuring a smooth and efficient experience from start to finish.",
  },
  {
    icon: <DollarSign size={18} />,
    title: "Transparent Pricing",
    description:
      "No hidden costs, no surprises. We believe in complete transparency and honest communication.",
  },
  {
    icon: <TrendingUp size={18} />,
    title: "End-to-End Solutions",
    description:
      "From company formation to accounting, tax, and digital growth, everything your business needs, all in one place.",
  },
  {
    icon: <Users size={18} />,
    title: "Dedicated Support",
    description:
      "Enjoy personalized assistance with a dedicated team that understands your business needs and goals.",
  },
];

export default function WhyChooseUs() {
  return (
    <section className="relative py-12 sm:py-16 lg:py-20 xl:py-24 px-4 bg-[#FAFAFA]">

      <div className="main-container">

        {/* TOP TEXT */}
        <div className="text-left md:text-center mb-12 sm:mb-16 lg:mb-20 max-w-3xl md:mx-auto">

          <p className="text-xs sm:text-sm uppercase tracking-[0.2em] text-[#B8893A] font-semibold mb-3">
            Why Choose Us
          </p>

          <h1
            className="font-bold text-[#000000]"
            style={{
              fontSize: "clamp(28px, 5vw, 48px)",
              fontWeight: "700",
              lineHeight: "1.3"
            }}
          >
            Build your business with{" "}
            <span className="font-serif font-normal text-[#B8893A]">Confidence</span>
          </h1>

          <p
            className="text-gray-500 mt-5 md:mx-auto"
            style={{
              fontSize: "clamp(14px, 1.2vw, 16px)",
              lineHeight: "1.6"
            }}
          >
            Backed by expert support and proven solutions for your business and growth in the UAE.
          </p>
        </div>

        {/* GRID (3+2 Layout) */}
        <div className="flex flex-wrap justify-center gap-6 xl:gap-8">

          {features.map((f, i) => (
            <div
              key={i}
              className="group bg-[#fafafa] border border-gray-100 rounded-2xl 
                         p-5 sm:p-6 lg:p-7
                         shadow-md hover:shadow-xl
                         transition-all duration-300 flex flex-col justify-between 
                         w-full sm:w-[calc(50%-1rem)] lg:w-[calc(33.33%-2rem)] xl:w-[calc(30%-1.5rem)] min-h-[250px]"
            >

              {/* TOP ROW */}
              <div className="flex items-start justify-between gap-4">

                <h3
                  className="font-semibold text-black group-hover:text-[#B8893A] transition"
                  style={{
                    fontSize: "clamp(18px, 2vw, 20px)",
                    fontWeight: "600",
                    lineHeight: "1.3"
                  }}
                >
                  {f.title}
                </h3>

                <div className="text-black/40 group-hover:text-[#B8893A] transition mt-1">
                  {f.icon}
                </div>

              </div>

          
              <div className="h-px bg-black/10 my-5 sm:my-6"></div>

              
              <p
                className="text-gray-600"
                style={{
                  fontSize: "clamp(14px, 1.2vw, 16px)",
                  lineHeight: "1.6"
                }}
              >
                {f.description}
              </p>

            </div>
          ))}

        </div>

      </div>

      
      <div className="absolute top-0 left-0 w-72 h-72 bg-[#B8893A]/5 blur-3xl rounded-full -z-10"></div>
      <div className="absolute bottom-0 right-0 w-72 h-72 bg-[#B8893A]/5 blur-3xl rounded-full -z-10"></div>

    </section>
  );
}
